/** 공용 폰트는 종류별 폴더에서 공유한다. */
export const FONT_ASSET_PREFIXES = {
    paperlogy: 'https://s.wink.co.kr/resources/ltp/fonts/common/paperlogy',
} as const;

export const fontAsset = (family: keyof typeof FONT_ASSET_PREFIXES, filename: string): string =>
    `${FONT_ASSET_PREFIXES[family]}/${filename.replace(/^\/+/, '')}`;
